// extracted by mini-css-extract-plugin
module.exports = {"Container":"About_Container__kLodL","Services":"About_Services__2htJ0","Service_Items":"About_Service_Items__1j0qi"};